import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Calculators from "@/components/Calculators";
import DocumentUpload from "@/components/DocumentUpload";
import AboutAgent from "@/components/AboutAgent";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <Calculators />
        <DocumentUpload />
        <AboutAgent />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
